import InVivoError from '@/model/InVivoError.ts';
import { ExceptionHandler } from '@/utils/ExceptionHandler';
import React, { ReactNode } from 'react';
import ErrorPage from './ErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  error: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = {
    error: false,
  };

  static getDerivedStateFromError(error: Error): State {
    ExceptionHandler.captureException(
      new InVivoError(`Unhandled exception: ${error?.message ?? '???'}`, {
        cause: error,
        slug: 'error-boundary',
        level: 'fatal',
      })
    );
    return {
      error: true,
    };
  }

  resetError = (): void => this.setState({ error: false });

  render(): ReactNode {
    if (this.state.error) {
      return <ErrorPage resetError={this.resetError} />;
    }
    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
